import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGypsum = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75039 11C7.16442 11.0002 7.50038 11.3359 7.50039 11.75C7.50039 12.1641 7.16443 12.4998 6.75039 12.5C6.33618 12.5 6.00039 12.1642 6.00039 11.75C6.0004 11.3358 6.33619 11 6.75039 11Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7504 11C11.1644 11.0002 11.5004 11.3359 11.5004 11.75C11.5004 12.1641 11.1644 12.4998 10.7504 12.5C10.3362 12.5 10.0004 12.1642 10.0004 11.75C10.0004 11.3358 10.3362 11 10.7504 11Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5004 7.74998C13.9144 7.75019 14.2504 8.08591 14.2504 8.49998C14.2504 8.91406 13.9144 9.24977 13.5004 9.24998C13.0862 9.24998 12.7504 8.91419 12.7504 8.49998C12.7504 8.08578 13.0862 7.74998 13.5004 7.74998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75039 6.99998C6.16442 7.00019 6.50038 7.33591 6.50039 7.74998C6.50039 8.16406 6.16443 8.49977 5.75039 8.49998C5.33618 8.49998 5.00039 8.16419 5.00039 7.74998C5.0004 7.33578 5.33619 6.99998 5.75039 6.99998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75039 6.99998C10.1644 7.00019 10.5004 7.33591 10.5004 7.74998C10.5004 8.16406 10.1644 8.49977 9.75039 8.49998C9.33618 8.49998 9.00039 8.16419 9.00039 7.74998C9.0004 7.33578 9.33619 6.99998 9.75039 6.99998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.75039 3.99998C9.16442 4.00019 9.50038 4.33591 9.50039 4.74998C9.50039 5.16406 9.16443 5.49977 8.75039 5.49998C8.33618 5.49998 8.00039 5.16419 8.00039 4.74998C8.0004 4.33578 8.33619 3.99998 8.75039 3.99998Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.29336 0.707011C8.65939 0.341267 9.23858 0.317687 9.63125 0.637675L9.70742 0.707011L17.2934 8.29295L17.3617 8.36814C17.6822 8.76092 17.6595 9.34182 17.2934 9.70799L9.70742 17.2939L9.63125 17.3613C9.26461 17.6605 8.7352 17.6605 8.36856 17.3613L8.29336 17.2939L0.706447 9.70799L0.638087 9.63084C0.339358 9.2642 0.339051 8.73461 0.638087 8.36814L0.706447 8.29295L8.29336 0.707011ZM1.41348 8.99998L8.99942 16.5859L16.5863 8.99998L9.00039 1.41404L1.41348 8.99998Z",
			fill: "black"
		})
	]
});
export default SvgGypsum;
